module.exports = __webpack_public_path__ + "static/fipcwhiterabbit1-77f3369a192e1e40166fd5ef1cadce14.jpeg";